import BOUsersTable from './BOUsersTable';

export default BOUsersTable;
